/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WebhookSummary } from './WebhookSummary';
import {
    WebhookSummaryFromJSON,
    WebhookSummaryFromJSONTyped,
    WebhookSummaryToJSON,
    WebhookSummaryToJSONTyped,
} from './WebhookSummary';

/**
 * 
 * @export
 * @interface ListWebhooksResponse
 */
export interface ListWebhooksResponse {
    /**
     * 
     * @type {Array<WebhookSummary>}
     * @memberof ListWebhooksResponse
     */
    webhooks: Array<WebhookSummary>;
    /**
     * Whether any delivery of the retention window exists, webhook or no webhook. Deliveries outlive a deleted webhook, so the Developers menu and the deliveries page stay reachable while there is history to read.
     * @type {boolean}
     * @memberof ListWebhooksResponse
     */
    hasRecentDeliveries: boolean;
}

/**
 * Check if a given object implements the ListWebhooksResponse interface.
 */
export function instanceOfListWebhooksResponse(value: object): value is ListWebhooksResponse {
    if (!('webhooks' in value) || value['webhooks'] === undefined) return false;
    if (!('hasRecentDeliveries' in value) || value['hasRecentDeliveries'] === undefined) return false;
    return true;
}

export function ListWebhooksResponseFromJSON(json: any): ListWebhooksResponse {
    return ListWebhooksResponseFromJSONTyped(json, false);
}

export function ListWebhooksResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListWebhooksResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'webhooks': ((json['webhooks'] as Array<any>).map(WebhookSummaryFromJSON)),
        'hasRecentDeliveries': json['hasRecentDeliveries'],
    };
}

  export function ListWebhooksResponseToJSON(json: any): ListWebhooksResponse {
      return ListWebhooksResponseToJSONTyped(json, false);
  }

  export function ListWebhooksResponseToJSONTyped(value?: ListWebhooksResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'webhooks': ((value['webhooks'] as Array<any>).map(WebhookSummaryToJSON)),
        'hasRecentDeliveries': value['hasRecentDeliveries'],
    };
}

